<template>
    <div>
        <mu-avatar icon="grid_on"></mu-avatar>
        <label>表格</label>
    </div>
</template>
<script>
export default {
    name: 'grid'
}
</script>



// WEBPACK FOOTER //
// grid.vue?4787ca5e